{
  "it": {
    "ai": {
      "assistant": {
        "all_projects": "Tutti i progetti",
        "cap": {
          "action": "Avvia una nuova conversazione",
          "message": "Ha raggiunto il limite di conversazioni."
        },
        "empty_state": {
          "subtitle": "Mi chieda qualsiasi cosa sui Suoi clienti",
          "title": "Come posso aiutarLa?"
        },
        "errors": {
          "budget_reached": "Il budget AI di questo mese è esaurito. Contatti Ziggu per aumentarlo.",
          "generic": "Qualcosa è andato storto. Riprovi."
        },
        "history": {
          "empty": "Nessuna conversazione precedente",
          "title": "Conversazioni precedenti"
        },
        "input": {
          "disclaimer": "I risultati potrebbero non essere accurati. Verifichi sempre le informazioni importanti.",
          "hint": "Invio per inviare · Maiusc+Invio per andare a capo",
          "placeholder": "Chieda dei Suoi clienti…"
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Come configuro le notifiche?",
          "help_project_settings": "Dove trovo le impostazioni del progetto?",
          "open_decisions": "Quali decisioni sono ancora aperte?",
          "unassigned_units": "Quali unità non hanno ancora un cliente?"
        },
        "support_cta": {
          "action": "Contatta il supporto",
          "prompt": "Non è la risposta che cercava?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Tutti i moduli",
          "assistant": "Assistente",
          "conversation_agent": "Agente conversazionale",
          "label": "Modulo"
        },
        "clients": {
          "allowance_split": "Gratuito {free} · A pagamento {paid}",
          "columns": {
            "allowance": "Budget",
            "chats": "Chat nel periodo",
            "client": "Cliente",
            "spend": "Spesa nel periodo",
            "status": "Stato",
            "used": "Utilizzato questo mese"
          },
          "empty": "Nessun cliente ha usato l'AI in questo periodo",
          "export": "Esporta",
          "title": "Clienti"
        },
        "empty_hint": "Nessun risultato per questo modulo e periodo.",
        "intent_mix": {
          "empty": "Nessuna chat in questo periodo",
          "row": "{chats} chat · {amount} | {chats} chat · {amount}",
          "title": "Distribuzione per intento"
        },
        "intents": {
          "draft": "Scrivi una bozza di risposta",
          "none": "Senza intento",
          "question": "Chiedi",
          "summary": "Riassunto"
        },
        "kpi": {
          "clients_active": "Clienti attivi",
          "employees_active": "Dipendenti attivi",
          "spend_month": "Spesa questo mese",
          "spend_month_detail": "Mese solare in corso",
          "spend_range": "Spesa nel periodo",
          "spend_range_detail": "{count} chat in questo periodo | {count} chat in questo periodo",
          "spend_today": "Spesa di oggi",
          "tickets_assisted": "Ticket assistiti"
        },
        "load_failed": {
          "description": "Ricarichi la pagina o scelga un altro periodo.",
          "title": "Impossibile caricare l'utilizzo dell'IA"
        },
        "range": {
          "label": "Periodo"
        },
        "spend": {
          "empty": "Nessuna spesa in questo periodo",
          "monthly_empty": "Nessuna spesa negli ultimi {months} mesi",
          "monthly_hint": "Ultimi {months} mesi · indipendente dal periodo selezionato",
          "monthly_title": "Costo per mese",
          "monthly_total": "{amount} negli ultimi {months} mesi · indipendente dal periodo selezionato",
          "title": "Spesa al giorno",
          "total": "{amount} nel periodo",
          "view": {
            "label": "Mostra spesa",
            "per_day": "Al giorno",
            "running_total": "Cumulativo"
          }
        },
        "status": {
          "over": "Budget superato",
          "over_days": "Superato · 1 giorno | Superato · {count} giorni"
        },
        "title": "Utilizzo AI"
      },
      "settings": {
        "budget": {
          "description": "Limite di spesa mensile per l'utilizzo dell'AI (fase di test). Ricalcolato in base all'utilizzo dei token in tutte le conversazioni di questo mese.",
          "free_label": "Budget gratuito",
          "override_help": "Lasci vuoto per utilizzare l'importo del pacchetto ({amount}).",
          "override_label": "Budget gratuito personalizzato",
          "paid_label": "Budget a pagamento",
          "save": "Salva",
          "title": "Budget mensile",
          "total_label": "Budget totale",
          "usage_label": "Utilizzato questo mese",
          "use_package_amount": "Usa l'importo del pacchetto"
        },
        "description": "Configurazione delle funzionalità AI nella Sua organizzazione.",
        "title": "Impostazioni AI",
        "usage": {
          "description": "Quanto del credito AI di questo mese è stato utilizzato. Al 100% le funzioni AI si fermano fino al rinnovo del credito il mese prossimo.",
          "title": "Utilizzo dell'AI"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Modifica",
          "ask": "Chiedi",
          "draft": "Scrivi una bozza di risposta",
          "draft_empty": "Ancora nessun messaggio a cui rispondere",
          "follow_up": "Approfondisci",
          "follow_up_stop": "Interrompi l'approfondimento",
          "new": "Nuova domanda",
          "summary": "Riassumi la conversazione",
          "summary_empty": "Ancora nessun messaggio da riassumere",
          "use_as_reply": "Usa come risposta"
        },
        "adjusting_draft": "Modifica di questa bozza",
        "beta": "Beta",
        "budget": {
          "description": "Il budget AI di questo mese è esaurito. Le risposte precedenti restano disponibili.",
          "request": "Abbiamo esaurito il budget AI di questo mese e vorremmo aumentarlo.",
          "request_low": "Abbiamo quasi esaurito il budget AI di questo mese e vorremmo aumentarlo.",
          "title": "Budget AI raggiunto",
          "warn": "{percent}% del budget AI di questo mese utilizzato."
        },
        "cap": "Questa chat è diventata lunga. Meglio fare una nuova domanda.",
        "collapse": "Nascondi assistente",
        "conversation": "Conversazione",
        "digest": {
          "decisions_open": "nessuna decisione aperta | 1 decisione aperta | {count} decisioni aperte",
          "installments_unpaid": "nessuna rata non pagata | 1 rata non pagata | {count} rate non pagate",
          "issues_open": "nessuna segnalazione post-vendita aperta | 1 segnalazione post-vendita aperta | {count} segnalazioni post-vendita aperte",
          "nothing_open": "Niente in sospeso per questa unità",
          "overdue": "{count} in ritardo",
          "title": "In sintesi"
        },
        "earlier_answers": "Risposte precedenti",
        "empty": "Chieda qualcosa su questa conversazione o inizi con una di queste.",
        "expand": "Mostra assistente",
        "following_up": "Approfondimento di questa risposta",
        "footer": "Visibile solo a Lei. Le risposte sono generate dall'AI e possono contenere errori.",
        "input": {
          "adjust_draft": "Modifichi questa bozza, ad es. più breve o più formale",
          "follow_up": "Faccia una domanda di approfondimento",
          "label": "La Sua domanda",
          "placeholder": "Chieda di questa conversazione"
        },
        "links": {
          "aftercare": "Post-vendita",
          "decisions": "Decisioni",
          "financials": "Finanze"
        },
        "placeholders": {
          "confirm": {
            "accept": "Invia comunque",
            "header": "Inviare con dati da completare?",
            "message": "L’assistente ha lasciato 1 dato da completare in questa risposta. | L’assistente ha lasciato {count} dati da completare in questa risposta."
          },
          "remaining": "1 dato da completare | {count} dati da completare"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Sostituisci",
            "header": "Sostituire il testo che ha scritto?",
            "message": "La bozza sostituisce il testo nella casella di risposta."
          }
        },
        "suggestions": {
          "history": "Qual è la storia con questo cliente?",
          "issues_open": "Quante segnalazioni post-vendita sono ancora aperte?",
          "undecided": "Cosa non ha ancora deciso questo cliente?"
        },
        "thinking": "L'assistente sta lavorando...",
        "title": "Assistente"
      }
    }
  }
}
